import BaseModel from "lib/model";
import assign from "lodash/assign";
import moment from "moment";
import { format } from "lib/globalize-util";

export default BaseModel.extend({
    idAttribute: "_id",

    props: {
        _id: {
            type: "string",
        },
        type: {
            type: "string",
            default: "refund",
        },
        amount: {
            type: "number",
        },
        status: {
            type: "string",
            required: true,
            values: [
                "new",
                "authorized",
                "reserved",
                "captured",
                "cancelled",
                "refunded",
                "charged back",
                "failed",
                "expired",
                "pending",
                "resolved",
                "declined",
                "fraud",
            ],
            default: "pending",
        },
        currency_code: {
            type: "string",
            required: true,
            default: "USD",
        },
        original_transaction_id: {
            type: "string",
        },
        paymentGroupId: {
            type: "string",
        },
        brand_payment_account_id: {
            type: "string",
        },
        description: {
            type: "string",
            required: true,
            default: "Refund",
        },
        transactionId: {
            type: "string",
        },
        detail: {
            type: "object",
        },
        maxAmount: {
            type: "number",
        },
        area: "string",
        source: "string",
        created_on: {
            type: "date",
            require: true,
        },
        cc: {
            type: "string",
        },
        card_type: {
            type: "string",
        },
        last_four: {
            type: "string",
        },
        created_by: {
            type: "string",
        },
        created_by_name: {
            type: "string",
        },
        created_by_email: {
            type: "string",
        },
        is_ach: {
            type: "boolean",
            default: false,
        },
    },

    derived: {
        formatted_created_on_day: {
            deps: ["created_on"],
            fn: function () {
                return moment(this.created_on).local().format("MMM DD, YYYY");
            },
        },
        formatted_created_on_time: {
            deps: ["created_on"],
            fn: function () {
                return moment(this.created_on).local().format("h:mm a");
            },
        },
        displayStatus: {
            deps: ["status"],
            fn: function () {
                return ["resolved", "authorized", "refunded", "captured"].indexOf(this.status) !== -1
                    ? format("Refund Amount")
                    : format("Attempted Amount");
            },
        },
    },
    url: function () {
        return this.is_ach
            ? "/api/v3.0/payment/payment-groups/refund"
            : `/payment-group/${this.paymentGroupId}/transaction/${this.original_transaction_id}/refund`;
    },
    validateRefund: function (key, value) {
        let error;
        switch (key) {
            case "amount":
                if (isNaN(Number(value))) {
                    error = "Amount must be a positive number";
                } else if (Number(value) < 1.0) {
                    //wepay does not accept refunds less than $1.00
                    error = "Amount must be at least $1.00";
                } else if (Number(value) > this.maxAmount) {
                    error = `Amount cannot be greater than ${this.maxAmount}.`;
                }
                break;
            default:
                error = false;
        }

        return error;
    },
    _validate: function (attrs, options) {
        if (!options.validate || !this.validate) {
            return true;
        }
        if (!options.validateJustCurrentAttrs) {
            attrs = assign({}, this.attributes, attrs);
        }
        const error = (this.validationError = this.validate(attrs, options) || null);

        if (!error) {
            return true;
        }
        this.trigger("invalid", this, error, assign(options || {}, { validationError: error }));
        return false;
    },
    validate: function (attrs) {
        const errors = {};

        Object.keys(attrs).forEach((key) => {
            const error = this.validateRefund(key, attrs[key]);
            if (error) {
                errors[key] = error;
            }
        });

        return Object.keys(errors).length ? errors : false;
    },
});
